module.exports = __webpack_public_path__ + "static/media/How-Java-Has-Advanced-In-The-Past-5-Years.a9c067d7.jpg";